import * as RoleTypes from "@wesstron/utils/Api/constants/roleTypes";
import {get, isEmpty} from "lodash";

const SERVICE_OVERRIDES = [
    RoleTypes.PAYMENTS_READ,
    RoleTypes.PAYMENTS_WRITE,
    RoleTypes.FIRMWARE_READ,
    RoleTypes.FIRMWARE_WRITE,
];

const DEBUG = true;
const debug = (...args) =>
    DEBUG ? console.log("[WithRolesUtils.displayComponent]", ...args) : {};

/**
 * szybkie sprawdzenie czy id placementu znajduje sie w obębie innego id
 * @param _plcmntId
 * @param _edgePlcmntId
 * @param buildingsList
 * @return {boolean}
 */
const isPlacementIdAscendantOfAnotherId = (
    _plcmntId,
    _edgePlcmntId,
    buildingsList
) => {
    const edge = buildingsList.find(({id}) => _edgePlcmntId === id);
    // nie znalizlismy edga wiec mozna od razu wyjsc
    debug("edge", edge);
    if (!edge) return false;
    let evaluating = buildingsList.find(({id}) => id === _plcmntId);
    while (evaluating) {
        debug("evaluatingId", evaluating.id);
        if (evaluating.id === edge.id) return true;
        evaluating = buildingsList.find(({id}) => id === evaluating.parentId);
    }
    return false;
};

/**
 * specjalne role, które odbiegają od zwykłych tym, że nie potrzeba mieć do nich przypisanej lokalizacji
 * @type {{}}
 * @private
 */
const _deviceRolesWithoutLocation = {
    [RoleTypes.DEVICE_FARM_WATCH_PRO_READ]: true,
    [RoleTypes.DEVICE_FARM_WATCH_PRO_WRITE]: true,
    [RoleTypes.DEVICE_PIG_COUNTER_WRITE]: true,
};

export const displayComponent = (
    roles = [],
    devPlcmnts,
    farm,
    user,
    buildingsMap,
    isService,
    licenses,
    requiredLicenses = {},
    hideFor = []
) => {
    debug(
        "args",
        roles,
        devPlcmnts,
        farm,
        user,
        buildingsMap,
        isService,
        licenses,
        requiredLicenses
    );
    // sprawdzanie pakietów licencyjnych
    if (hideFor.some((type) => type === user.UserType)) return false;
    // sprawdzanie roli tylko dla nie-serwisu
    debug("isService", isService);
    console.log(
        "roles",
        roles,
        isService,
        roles.some((role) => !SERVICE_OVERRIDES.includes(role))
    );
    if (isService && roles.some((role) => !SERVICE_OVERRIDES.includes(role))) {
        console.log("service resolved");
        return true;
    }
    // Check AND licenses - all must exist
    if (requiredLicenses.and) {
        for (let licensePath of requiredLicenses.and) {
            const hasLicense = get(licenses, licensePath);
            if (!hasLicense) {
                debug("missing license", licensePath);
                return false;
            }
        }
    }
    // Check OR licenses - at least one must exist
    if (requiredLicenses.or) {
        const hasAtLeastOne = requiredLicenses.or.some((licensePath) => {
            return get(licenses, licensePath);
        });
        console.log("hasAtLeastOne", hasAtLeastOne, requiredLicenses.or);
        if (!hasAtLeastOne) {
            debug("missing at least one license from", requiredLicenses.or);
            return false;
        }
    }
    for (let role of roles) {
        let hasRole = get(user, "Roles", []).find((r) => {
            if (Array.isArray(role)) {
                const foundedRole = role.find(
                    (optionalRole) => optionalRole === r.Role
                );
                if (foundedRole) role = foundedRole;
            }
            return r.Role === role;
        });
        debug("hasRole", hasRole);
        if (!hasRole) return false;
        // sprawdzenie czy użytkownik ma prawa do aktualnej farmy, sprawdza czy jest farma, aby móc pokazać farmChoosera
        debug("hasFarm", farm);
        if (farm) {
            let hasRightsToFarm = hasRole.LocalRights.find(
                (item) => item.FarmID === farm
            );
            debug("hasRightsToFarm", hasRightsToFarm);
            if (!hasRightsToFarm) return false;
            debug("devPlcmnts", devPlcmnts);
            // jesli przekazano devPlcmnts jako arraya walidujemy pod katem posiadanych rol
            if (Array.isArray(devPlcmnts)) {
                // jeśli jest ono puste to tylko serwis, chyba z mamy do czynienia ze specjalna rola
                if (isEmpty(devPlcmnts)) {
                    return _deviceRolesWithoutLocation[role] ?? false;
                } else {
                    // device config nie ma plcmts wiec sprawdzamy czy zostala przekazana jeszcze inna role z devicami
                    if (
                        role !== RoleTypes.DEVICE_CONFIG &&
                        role.startsWith("_DEVICE")
                    ) {
                        // role do oczytow nie moga byc do miejsc przypisane
                        const rolePlmcnts = get(hasRightsToFarm, "Plcmnts", []);
                        if (role.endsWith("_READ") && rolePlmcnts.length === 0)
                            return true;
                        // jesli user ma gwiazdke to przepuszczamy
                        if (rolePlmcnts[0] === "*") {
                            return true;
                        } else {
                            debug("rolePlmcnts", rolePlmcnts);
                            // jesli ma jakies wspolne plcmnty to przepuszczamy, w innym wypadku trzeba sprawdzić czy przypadkiem plcmtn device'a
                            // nie zawiera sie w tym co ma user
                            return rolePlmcnts.some((rolePlacementId) => {
                                return devPlcmnts.some((devicePlacementId) => {
                                    return isPlacementIdAscendantOfAnotherId(
                                        devicePlacementId,
                                        rolePlacementId,
                                        buildingsMap
                                    );
                                });
                            });
                        }
                    }
                }
            }
        }
    }
    return true;
};
